export const PROMOCODE_ACTION_TYPES = {
    POST_PROMO_CODE: 'promoCode/postPromoCode',
};
